import React, { useState } from 'react';
import { GiftIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
interface Bonus {
  emoji: string;
  title: string;
  tagline: string;
  image?: string;
  items: string[];
}
const bonuses: Bonus[] = [{
  emoji: '🗂️',
  title: "BONUS 1 — Kit di Modelli Clinici Pronti all'Uso",
  tagline: 'Ciò che useresti il tuo primo giorno di lavoro',
  image: 'https://cdn.magicpatterns.com/uploads/fYd82N1RoWJDVpDuEPX1PC/Screenshot_2026-06-03_at_10.41.20_AM.png',
  items: ['Cartella clinica editabile in Word/PDF', 'Checklist di anamnesi per specie (cane, gatto, coniglio, roditore)', 'Scheda di monitoraggio del paziente ricoverato', 'Modulo di consenso informato per il proprietario', "Foglio di calcolo di fluidi e dosaggi d'emergenza"]
}, {
  emoji: '💊',
  title: 'BONUS 2 — Prontuario Veterinario Sintetico: I 50 Farmaci Essenziali',
  tagline: 'Il PDF che terrai sempre aperto sul cellulare',
  image: 'https://cdn.magicpatterns.com/uploads/j1Hz187Hsyego9ttFfYGug/Screenshot_2026-06-03_at_10.44.17_AM.png',
  items: ['50 farmaci con: dose, via, frequenza, specie, note', 'Ordinato per sistema (digerente, cardiovascolare, nervoso, antibiotici, ecc.)', 'Segnalati i farmaci ⚠️ pericolosi nei gatti', "Include dosaggi d'emergenza evidenziati in rosso", 'Formato tabella, ottimizzato per stampa A4 o per il cellulare']
}, {
  emoji: '🧠',
  title: "BONUS 3 — Raccolta di 50 Domande d'Esame con Risposte Spiegate",
  tagline: 'Studia come se sapessi già cosa ti chiederanno',
  image: 'https://cdn.magicpatterns.com/uploads/2oY2dF5GX8ansQNnTYm7GH/Screenshot_2026-06-03_at_10.45.58_AM.png',
  items: ['50 domande a scelta multipla in stile universitario', 'Copre: farmacologia, clinica, emergenze e laboratorio', 'Ogni risposta ha una spiegazione clinica dettagliata', 'Organizzate per difficoltà: base / intermedia / avanzata']
}, {
  emoji: '🗺️',
  title: 'BONUS 4 — Mappa Mentale delle Diagnosi Differenziali per Segno Clinico',
  tagline: "La mappa che ti dice cosa pensare quando l'animale non parla",
  image: 'https://cdn.magicpatterns.com/uploads/5ygdR8sP66oNLqhU8VgjL9/Screenshot_2026-06-03_at_10.32.03_AM.png',
  items: ['15 segni clinici chiave (vomito, diarrea, convulsioni, dispnea, poliuria, collasso, ittero, ecc.)', 'Per ogni segno: albero di diagnosi differenziali ordinate per probabilità', 'Differenziazione per specie (cane vs. gatto) dove necessario', 'Formato visivo tipo mappa mentale, ottimizzato per stampa A3 o tablet', 'Ideale da portare in tirocinio come guida di consultazione rapida']
}, {
  emoji: '📅',
  title: 'BONUS 5 — Pianificatore di Studio di 90 Giorni per Veterinaria',
  tagline: 'Trasforma il tuo caos di appunti in un piano con scadenza',
  image: 'https://cdn.magicpatterns.com/uploads/6rxyN2HYq3uDvZLVKmjqnj/Screenshot_2026-06-03_at_10.35.22_AM.png',
  items: ['Cronoprogramma settimanale di 90 giorni organizzato per materie e blocchi tematici', 'Sistema di ripetizione dilazionata per trattenere ciò che studi a lungo termine', 'Tracker giornaliero delle abitudini: ore di studio, riposo, ripasso e pratica clinica', 'Checklist di obiettivi settimanali con caselle da spuntare', 'Pensato per studenti di qualsiasi anno del corso']
}, {
  emoji: '⚠️',
  title: 'BONUS 6 — Guida alle Intossicazioni Frequenti in Cani e Gatti',
  tagline: 'Ciò che devi sapere prima che il proprietario arrivi nel panico',
  image: 'https://cdn.magicpatterns.com/uploads/797XHMV5qdeNbuXLSMHaD2/Screenshot_2026-06-03_at_10.34.36_AM.png',
  items: ['20 sostanze tossiche più frequenti in visita: ibuprofene, paracetamolo, cioccolato, uva, xilitolo, organofosfati, rodenticidi, piante tossiche e altro', "Per ogni tossico: meccanismo di danno, segni clinici, finestra d'azione e protocollo di gestione", 'Tabella delle dosi tossiche per kg per i più comuni', 'Cosa fare e cosa NON fare nei primi 30 minuti', 'Formato scheda tascabile, stampabile e con codice colore per urgenza']
}];
export function Bonuses() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="w-full py-14 px-4 bg-gradient-to-b from-white to-green-50/50" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <div className="text-center mb-8" data-id="element-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-100 text-yellow-800 font-bold text-sm mb-3" data-id="element-15">
            <GiftIcon className="w-4 h-4" data-id="element-16" /> BONUS INCLUSI
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-17">
            + 6 BONUS in regalo
          </h2>
        </div>

        <div className="space-y-2.5" data-id="element-18">
          {bonuses.map((b, i) => {
          const isOpen = openIdx === i;
          return <div key={i} className={`rounded-xl border-2 overflow-hidden transition-all ${isOpen ? 'border-green-400 bg-white shadow-md' : 'border-green-100 bg-white hover:border-green-300'}`} data-id="element-19">
                {b.image && <div className="relative w-full h-20 sm:h-24 overflow-hidden bg-slate-50" data-id="element-20">
                    <img src={b.image} alt={b.title} className="w-full h-full object-cover object-top opacity-90" data-id="element-21" />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/40 to-white pointer-events-none" data-id="element-22" />
                  </div>}

                <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left" data-id="element-23">
                  <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-24">
                    <span className="text-2xl flex-shrink-0" data-id="element-25">{b.emoji}</span>
                    <div className="min-w-0" data-id="element-26">
                      <h3 className="font-extrabold text-sm sm:text-base text-slate-900 leading-tight" data-id="element-27">
                        {b.title}
                      </h3>
                      <p className="text-xs sm:text-sm text-green-700 italic mt-0.5 truncate" data-id="element-28">
                        "{b.tagline}"
                      </p>
                    </div>
                  </div>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 text-green-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-29" />
                </button>

                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-30">
                  <div className="overflow-hidden" data-id="element-31">
                    <ul className="px-4 pb-4 space-y-1.5 border-t border-green-100 pt-3" data-id="element-32">
                      {b.items.map((it, j) => <li key={j} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-33">
                          <CheckIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-34" />
                          <span className="leading-snug" data-id="element-35">{it}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}